/*
 *
 * RecordProcesses reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_PROCESS_HISTORY_WATCHER,
  GET_PROCESS_HISTORY_SUCCESS,
  GET_PROCESS_HISTORY_FAILED,
} from "./constants"

export const initialState = fromJS({
  processHistories: [],
  isLoadingProcessHistores: undefined,
})

function recordProcessesReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PROCESS_HISTORY_WATCHER:
      return state
        .set("processHistories", [])
        .set("isLoadingProcessHistories", undefined)
    case GET_PROCESS_HISTORY_SUCCESS:
      return state
        .set("processHistories", action.payload)
        .set("isLoadingProcessHistories", false)
    case GET_PROCESS_HISTORY_FAILED:
      return state.set("processHistories", []).set("isLoadingProcessHistories", false)

    default:
      return state
  }
}

export default recordProcessesReducer
